export const connexionProps = () => ({
  error: {
    type: Object,
    required: false,
    default: null
  },
  state: {
    type: String,
    default: null,
    required: false
  },
  displayCreateAccount: {
    type: Boolean,
    required: false,
    default: true
  },
  captchaKey: {
    type: String,
    required: false,
    default: null
  }
})

export const connexionEmits = () => ([
  "connexion"
])

export const useConnexion = (context) => {
  const email = ref(null);
  const emailSended = ref(false);

  const resetFormPassword = () => {
    emailSended.value = false;
    email.value = null;
  };

  const resetPassword = (e) => {
    email.value = e;
    emailSended.value = true;
  };

  const connexion = (loginObj) => {
    context.emit("connexion", loginObj);
  };

  return {
    email,
    emailSended,
    resetFormPassword,
    resetPassword,
    connexion
  }
}